// removed by extract-text-webpack-plugin
module.exports = {"background":"_3z-bs","bold":"_369rB"};